import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import styles from './index.module.scss';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { Error } from 'components/message/Error';
import { showError, showSuccess } from 'utils';
import { createPickPackList } from 'services';

const validationSchema = yup.object().shape({
  name: yup.string().required(),
});

type FormData = {
  name: string;
};

const CreatePickPack = props => {
  const [loading, setLoading] = useState<boolean>(false);
  
  const {
    register,
    handleSubmit,
    errors,
  } = useForm<FormData>({ resolver: yupResolver(validationSchema) });
  
  const createPickPackFn = handleSubmit(async ({ name }) => {
    setLoading(true);
    const data = {
      name,
    };
    
    try {
      const response = await createPickPackList(data);
      showSuccess('Pick Pack created successfully.');
      props.history.replace(`/pick-packs/${response.id}`);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  });

  return (
    <div className={styles['main-container']}>
      <div className={styles['header']}>
        <div className={styles['heading']}>Create a New Pick Pack</div>
      </div>
      <div className={styles['pick-pack-details']}>
        <div className={styles['name']}>
          <div className={styles['label']}>Name</div>
          <input
            name={'name'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
          {errors.name && <Error message={errors.name.message} />}
        </div>
      </div>
      <div className={styles['footer']}>
        <ActionButton
          text={'Cancel'}
          active={!loading}
          isLoading={false}
          onClick={() => props.history.goBack()}
          customClass={styles['cancel']}
        />
        <ActionButton
          text={'Create Pick Pack'}
          active={!loading}
          isLoading={loading}
          onClick={createPickPackFn}
        />
      </div>
    </div>
  );
};

export { CreatePickPack };
